import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = <>
    <h2 className="text-2xl font-serif text-brown mb-6" data-id="element-30">
      Política de Privacidad
    </h2>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-31">
      1. Información que recopilamos
    </h3>
    <p className="mb-4" data-id="element-32">
      Recopilamos información personal que usted nos proporciona directamente,
      como su nombre y dirección de correo electrónico al realizar una compra o
      suscribirse a nuestro boletín.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-33">
      2. Uso de la información
    </h3>
    <p className="mb-4" data-id="element-34">
      Utilizamos su información para procesar transacciones, enviar
      comunicaciones relacionadas con su compra y mejorar nuestros productos y
      servicios. No vendemos ni compartimos su información personal con terceros
      con fines de marketing.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-35">
      3. Protección de datos
    </h3>
    <p className="mb-4" data-id="element-36">
      Implementamos medidas de seguridad técnicas y organizativas para proteger
      su información personal contra acceso no autorizado, alteración,
      divulgación o destrucción.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-37">4. Cookies</h3>
    <p className="mb-4" data-id="element-38">
      Nuestro sitio web puede utilizar cookies para mejorar su experiencia de
      navegación. Usted puede configurar su navegador para rechazar cookies,
      aunque esto podría afectar la funcionalidad del sitio.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-39">5. Sus derechos</h3>
    <p className="mb-4" data-id="element-40">
      Usted tiene derecho a acceder, rectificar o eliminar su información
      personal en cualquier momento. También puede solicitar la limitación del
      procesamiento de sus datos.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-41">
      6. Cambios a esta política
    </h3>
    <p data-id="element-42">
      Nos reservamos el derecho de actualizar esta política de privacidad en
      cualquier momento. Los cambios serán publicados en esta página con la
      fecha de la última actualización.
    </p>
  </>;
const termsContent = <>
    <h2 className="text-2xl font-serif text-brown mb-6" data-id="element-43">
      Términos y Condiciones
    </h2>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-44">
      1. Aceptación de los términos
    </h3>
    <p className="mb-4" data-id="element-45">
      Al acceder y utilizar este sitio web y adquirir nuestros productos, usted
      acepta estar sujeto a estos términos y condiciones de uso.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-46">
      2. Productos y servicios
    </h3>
    <p className="mb-4" data-id="element-47">
      Nuestros productos son de carácter informativo y educativo. No sustituyen
      el consejo médico profesional. Consulte siempre con un profesional de la
      salud antes de iniciar cualquier programa de bienestar.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-48">
      3. Política de reembolso
    </h3>
    <p className="mb-4" data-id="element-49">
      Ofrecemos una garantía de satisfacción de 30 días. Si no está satisfecho
      con su compra, puede solicitar un reembolso completo dentro de los 30 días
      posteriores a la fecha de compra.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-50">
      4. Propiedad intelectual
    </h3>
    <p className="mb-4" data-id="element-51">
      Todo el contenido de este sitio web, incluyendo textos, gráficos,
      logotipos e imágenes, es propiedad de Bienestar Natural y está protegido
      por las leyes de propiedad intelectual. Queda prohibida su reproducción
      sin autorización.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-52">
      5. Limitación de responsabilidad
    </h3>
    <p className="mb-4" data-id="element-53">
      Los resultados pueden variar de persona a persona. No garantizamos
      resultados específicos derivados del uso de nuestros productos o
      servicios.
    </p>

    <h3 className="text-lg font-semibold text-brown mb-2" data-id="element-54">6. Ley aplicable</h3>
    <p data-id="element-55">
      Estos términos se regirán e interpretarán de acuerdo con las leyes
      aplicables en su jurisdicción.
    </p>
  </>;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brown py-8 px-6" data-id="element-56">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-57">
          <p className="text-cream/50 text-sm" data-id="element-58">
            © {new Date().getFullYear()} Bienestar Natural. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-59">
            <button onClick={() => setActiveModal('privacy')} className="text-cream/50 hover:text-cream text-sm transition-colors duration-200" data-id="element-60">
              Privacy Policy
            </button>
            <span className="text-cream/20" data-id="element-61">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-cream/50 hover:text-cream text-sm transition-colors duration-200" data-id="element-62">
              Terms & Conditions
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      <AnimatePresence data-id="element-63">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brown/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-64">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="bg-cream-light rounded-2xl shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-65">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-cream" data-id="element-66">
                <span className="text-sm font-medium tracking-widest uppercase text-terracotta" data-id="element-67">
                  {activeModal === 'privacy' ? 'Privacidad' : 'Términos'}
                </span>
                <button onClick={() => setActiveModal(null)} className="text-brown-light hover:text-brown transition-colors p-1 rounded-full hover:bg-cream" data-id="element-68">
                  <X className="w-5 h-5" data-id="element-69" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 sm:p-8 overflow-y-auto max-h-[calc(80vh-72px)] text-brown-light leading-relaxed text-base" data-id="element-70">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}